import { Fragment, ReactNode } from "react";
import { api } from "~/utils/api";
import { User } from "~/modules/user/store/types";
import { ApiKey } from "../../types";

// // // //

// - Fetches list of items from the API
// - Renders error message if request fails
// - Passes items + loading state to props.childen
export function ApiKeyListFetcher(props: {
    user: User;
    children: (childProps: {
        loading: boolean;
        error: boolean;
        apiKeys: ApiKey[];
        refetchApiKeys: () => void;
    }) => ReactNode;
}) {
    const { user } = props;

    // Fetch items via tRPC
    const listRequest = api.apiKeys.getAll.useQuery({
        organizationID: user.organization.id,
    });
    const apiKeys = listRequest.data || [];

    // Set loading + error state
    const loading = listRequest.isLoading || false;
    const error = listRequest.error !== undefined;

    // Render props.children
    return (
        <Fragment>
            {props.children({
                error,
                loading,
                apiKeys: apiKeys.filter((apiKey) => !apiKey.archived),
                refetchApiKeys: () => {
                    listRequest.refetch();
                },
            })}
        </Fragment>
    );
}
